// Synced from Tolgee at build time by scripts/sync-translations.js
import en from './fallback/en.json';

export default () => en;
